import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { BehaviorSubject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { EsppQuoterComponent } from 'src/app/modules/espp/modules/espp-quoter/espp-quoter.component';
import { QuoteService } from '../quote.service';
import { MatDialogRef } from '@angular/material/dialog';
import { Quote } from 'src/app/core/types/quote';

@Injectable({  providedIn: 'root'})
export class QuoteFormService {

    public modalMessage = new BehaviorSubject<string[]>([]);
    private quoteFormDialogRef: MatDialogRef<EsppQuoterComponent> | null = null;

    constructor(public dialog: MatDialog, private quoteService: QuoteService) { }

    public showQuoteForm(quoteID: number | null = null, message: string |  null = null, showMesages: boolean = false){
        if(!quoteID){
            const dialogRef = this.dialog.open(EsppQuoterComponent, {
                disableClose: true,
                panelClass:'quote-dialog',
               });
            this.quoteFormDialogRef = dialogRef;
            dialogRef.afterClosed().subscribe(() => {
                if (this.quoteFormDialogRef === dialogRef) {
                    this.quoteFormDialogRef = null;
                }
            });
               return
        }
        if(showMesages){
            this.modalMessage.next(["All date fields must be populated in order to apply for coverage. Please complete the fields in order to update your quote and proceed to the application."])
        }
        console.log(showMesages,this.modalMessage.value)
        // Reuse the quote already loaded by the View page (SingleQuoteResolver
        // populates currentQuote) instead of re-issuing the heavy GET /quotes/{id}.
        // Mirrors the resolver's guard and re-applies getQuote's derived-state
        // side-effects so the edit modal is populated identically to a fetch.
        const cachedQuote = this.quoteService.currentQuote.value;
        if (cachedQuote && quoteID == cachedQuote.id) {
            this.quoteService.primeQuoteDerivedState(cachedQuote as Quote);
            const dialogRef = this.dialog.open(EsppQuoterComponent, {
                disableClose: true,
                panelClass: 'quote-dialog',
                data: cachedQuote
            });
            this.quoteFormDialogRef = dialogRef;
            dialogRef.afterClosed().subscribe(() => {
                if (this.quoteFormDialogRef === dialogRef) {
                    this.quoteFormDialogRef = null;
                }
            });
            return;
        }
        this.quoteService.getQuote(quoteID)
            .pipe(
                tap( quote => {
                    const dialogRef = this.dialog.open(EsppQuoterComponent, {
                        disableClose: true,
                        panelClass:'quote-dialog',
                        data: quote
                       });
                    this.quoteFormDialogRef = dialogRef;
                    dialogRef.afterClosed().subscribe(() => {
                        if (this.quoteFormDialogRef === dialogRef) {
                            this.quoteFormDialogRef = null;
                        }
                    });

                    //    dialogRef.afterClosed().subscribe(result => {
                    //     console.log('close')
                    //     this.modalMessage.next([])
                    //   });
                })
            )
            .subscribe(quote => {
                // this.dialog.open(EsppQuoterComponent, { 
                //     disableClose: true,
                //     data: quote
                //    });
            })
    }

    public closeQuoteForm(){
        this.modalMessage.next([])
        if (this.quoteFormDialogRef) {
            this.quoteFormDialogRef.close();
            this.quoteFormDialogRef = null;
        }
    }
}
